import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/package.svg'
import _imports_1 from '../assets/pkg-list-arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-5e3c21d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "package-list-item" }
const _hoisted_2 = {
  key: 0,
  class: "bubble"
}
const _hoisted_3 = { class: "package-data-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "package-data-heading" }, "Description", -1))
const _hoisted_5 = { class: "package-data-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "package-data-heading" }, "Launch Files", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-div node-bg" }, null, -1))
const _hoisted_8 = { class: "package-data-item-text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "icon-button" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "package-list-arrow arrow-rotated"
  })
], -1))
const _hoisted_10 = { class: "package-data-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "package-data-heading" }, "Topics", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-div topic-bg" }, null, -1))
const _hoisted_13 = { class: "package-data-item-text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "icon-button" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "package-list-arrow arrow-rotated"
  })
], -1))
const _hoisted_15 = { class: "package-data-box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "package-data-heading" }, "Services", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-div service-bg" }, null, -1))
const _hoisted_18 = { class: "package-data-item-text" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "icon-button" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "package-list-arrow arrow-rotated"
  })
], -1))
const _hoisted_20 = { class: "package-data-box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "package-data-heading" }, "Nodes", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle-div node-bg" }, null, -1))
const _hoisted_23 = { class: "package-data-item-text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "icon-button" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "package-list-arrow arrow-rotated"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon-button",
        onDblclick: _cache[0] || (_cache[0] = ($event: any) => (
        _ctx.pkg.robotPackage ||
          _ctx.$router.push(`/nodesCanvas/${_ctx.workspaceId}/${_ctx.pkg.name}/${_ctx.pkg.id}`)
      ))
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: _normalizeClass({ 'red-svg': _ctx.pkg.robotPackage })
        }, null, 2)
      ], 32),
      _createElementVNode("button", {
        class: "icon-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = !_ctx.open))
      }, [
        _createElementVNode("img", {
          src: _imports_1,
          class: _normalizeClass(["package-list-arrow", {
          'arrow-rotated': !_ctx.open
        }])
        }, null, 2)
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.pkg.name), 1)
    ]),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.pkg.description || 'No description found.'), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pkg.launchFiles, (launchFile) => {
              return (_openBlock(), _createElementBlock("div", {
                key: launchFile.name,
                class: "package-data-item"
              }, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(launchFile.name), 1),
                _hoisted_9
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pkg.topics, (topic) => {
              return (_openBlock(), _createElementBlock("div", {
                key: topic.name,
                class: "package-data-item"
              }, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, _toDisplayString(topic.name), 1),
                _hoisted_14
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pkg.services, (service) => {
              return (_openBlock(), _createElementBlock("div", {
                key: service.name,
                class: "package-data-item"
              }, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, _toDisplayString(service.name), 1),
                _hoisted_19
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pkg.nodes, (node) => {
              return (_openBlock(), _createElementBlock("div", {
                key: node.name,
                class: "package-data-item"
              }, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(node.name), 1),
                _hoisted_24
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}